import { render, staticRenderFns } from "./TestAppMenu.vue?vue&type=template&id=63e32e86&scoped=true&"
import script from "./TestAppMenu.vue?vue&type=script&lang=js&"
export * from "./TestAppMenu.vue?vue&type=script&lang=js&"
import style0 from "./TestAppMenu.vue?vue&type=style&index=0&id=63e32e86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e32e86",
  null
  
)

export default component.exports